import i18n from '../../../../i18n';

export const AdminMenus = [
  // {
  //   label: "Dashboard",
  //   key: "dashboard",
  //   icon: "ic:round-dashboard",
  // },

  {
    label: () => i18n.t('sidebar.manageUser', 'Manage User'),
    key: "manage-user",
    icon: "solar:users-group-rounded-line-duotone",
  },
  {
    label: () => i18n.t('sidebar.manageApps', 'Manage Apps'),
    key: "manage-apps",
    icon: "solar:widget-2-line-duotone",
  },
  {
    label: () => i18n.t('sidebar.dataScheduler', 'Data Scheduler'),
    key: "data-scheduler",
    icon: "mingcute:time-line",
  }
];
